import { render, staticRenderFns } from "./button-search.vue?vue&type=template&id=5878051a&"
import script from "./button-search.vue?vue&type=script&lang=js&"
export * from "./button-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports